import {
  ADD_USER,
  EDIT_USER,
  EDIT_USER_PASSWORD,
  DELETE_USER,
  FETCH_USERS,
  FETCH_ROLES
} from "./actionTypes";
import axios from "axios";
import {
  infoAddToast,
  infoEditToast,
  infoDeleteToast
} from "../components/Toast";
import { USERS_URL, ROLES_URL, USER_CREDENTIALS_URL } from "../../config";

/**
 * Pobieranie listy uzytkownikow z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchUsers = callback => {
  return dispatch => {
    return axios
      .get(USERS_URL)
      .then(response => {
        dispatch(fetchUsersSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Pobieranie listy rol uzytkownikow z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchUserRoles = callback => {
  return dispatch => {
    return axios
      .get(ROLES_URL)
      .then(response => {
        dispatch(fetchUserRolesSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Tworzenie uzytkownika na serwerze
 *
 * @param user obiekt uzytkownika do stworzenia
 */
export const createUser = user => {
  return dispatch => {
    return axios
      .post(`${USERS_URL}`, JSON.stringify(user), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(createUserSuccess(response.data));
        infoAddToast();
      });
  };
};

/**
 * Aktualizacja użytkownika na serwerze
 *
 * @param user obiekt uzytkownika do aktualizacji
 */
export const updateUser = user => {
  return dispatch => {
    return axios
      .put(`${USERS_URL}/${user.id}`, JSON.stringify(user), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(updateUserSuccess(response.data));
        infoEditToast();
      });
  };
};

/**
 * Aktualizacja hasła użytkownika na serwerze
 *
 * @param user obiekt hasła uzytkownika do aktualizacji
 */
export const updateUserPassword = userPassword => {
  return dispatch => {
    return axios
      .put(USER_CREDENTIALS_URL(userPassword.id), JSON.stringify(userPassword), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(updateUserPasswordSuccess(response.data));
        infoEditToast();
      });
  };
};

/**
 * Kasowanie uzytkownika z serwera
 *
 * @param id identyfikator uzytkownika do skasowania
 */
export const deleteUser = id => {
  return dispatch => {
    return axios.delete(`${USERS_URL}/${id}`).then(response => {
      dispatch(deleteUserSuccess(id));
      infoDeleteToast();
    });
  };
};

/**
 * Akcja pomyślnego pobrania listy użytkowników 
 * 
 * @param {object} data obiekt pobranej listy użytkowników
 */
export const fetchUsersSuccess = data => {
  return {
    type: FETCH_USERS,
    payload: data
  };
};

/**
 * Akcja pomyślnego pobrania listy ról użytkwoników 
 * 
 * @param {object} data obiekt pobranej listy ról
 */
export const fetchUserRolesSuccess = data => {
  return {
    type: FETCH_ROLES,
    payload: data
  };
};

/**
 * Akcja pomyślnego utworzenia użytkownika
 * 
 * @param {object} data object utworzonego użytkownika
 */
export const createUserSuccess = data => {
  return {
    type: ADD_USER,
    payload: data
  };
};

/**
 * Akcja pomyślnej aktualizacji użytkownika 
 * 
 * @param {object} data obiekt zaktualizowanego użytkownika
 */
export const updateUserSuccess = data => {
  return {
    type: EDIT_USER,
    payload: data
  };
};

/**
 * Akcja pomyślnej aktualizacji hasła 
 * 
 * @param {object} data obiekt zaktualizowanego hasła
 */
export const updateUserPasswordSuccess = data => {
  return {
    type: EDIT_USER_PASSWORD,
    payload: data
  };
};

/**
 * Akcja pomyślnego skasowania użytkownika 
 * 
 * @param {number} id identyfikator użytkownika skasowanego
 */
export const deleteUserSuccess = id => {
  return {
    type: DELETE_USER,
    payload: id
  };
};
